export default "__VITE_ASSET__DPIX3Kns__"